import { render, staticRenderFns } from "./RoomsMemberList.vue?vue&type=template&id=88f7f0e4&scoped=true"
import script from "./RoomsMemberList.vue?vue&type=script&lang=ts"
export * from "./RoomsMemberList.vue?vue&type=script&lang=ts"
import style0 from "./RoomsMemberList.vue?vue&type=style&index=0&id=88f7f0e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f7f0e4",
  null
  
)

export default component.exports